/**
 * @Page RST03
 * @Description 실사재고 > 기준정보 > 품목그룹등록
 **/
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import Ribbon from '@/components/organisms/Ribbon';
import GridRibbon from "@/components/organisms/GridRibbon";
import ContentXearch from '@/components/organisms/ContentXearch';
import Content from '@/components/organisms/Content';
import Grid from '@/components/grid/agGrid';
import CustomAlert from "@/components/molecules/CustomAlert";
import AlertDialog from '@/components/material-UI/AlertDialog';
import Popup from '@/pages/Popup/Popup';
import * as Common from '@/utils/Common';
import CommonUtil from '@/utils/CommonUtil';

const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER;
const Utils = new CommonUtil();

const useYnList = [
    { "comCode": "*", "text": "전체" },
    { "comCode": "Y", "text": "사용" },
    { "comCode": "N", "text": "미사용" },
];

function RST03() {

    const token = Common.getToken();
    const userId = Common.getToken("id");
    const tVnt1 = Common.getToken("vand");
    const tComp = Common.getToken("comp");
    const ckVnt1 = Common.getCookie("ck_vnt1" + userId) ? Common.getCookie("ck_vnt1" + userId) : tVnt1;

    const grdRST03Main = useRef(); // 좌측: 그룹코드
    const grdRST03Detail = useRef(); // 우측: 그룹코드 품목

    // ─── 상태 ────────────────────────────────────────────────────────────
    const [idata, setData] = useState({
        kVnt1: ckVnt1,
        kComp: tComp,       //회사구분
        kGrtp: "",       // 조회조건 그룹코드
        kGryn: "*",      // 조회조건 사용여부
    });

    const [message, setMessage] = useState({ openAlert: false, severity: "success", msg: "" });
    const { openAlert, severity, msg } = message;

    const [dlgMessage, setDlgMessage] = useState({ openDlg: false, dlgTrans: "", dlgMsg: "" });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;

    // 현재 선택된 그룹코드 (우측 그리드 조회에 사용)
    const [currentGrtp, setCurrentGrtp] = useState("");

    // 품번 목록 (rom4l/search 결과)
    const [ptnoList, setPtnoList] = useState([]);
    // 품번→품명 맵
    const [ptnoMap, setPtnoMap] = useState({});

    // ─── Grid API 상태 ───────────────────────────────────────────────────
    let [searchApi, setSearchApi] = useState(false); // 좌측 그룹코드 조회
    let [insertApi, setInsertApi] = useState(false); // 좌측 등록
    let [updateApi, setUpdateApi] = useState(false); // 좌측 수정
    let [deleteApi, setDeleteApi] = useState(false); // 좌측 삭제

    let [searchApi2, setSearchApi2] = useState(false); // 우측 품목 조회
    let [insertApi2, setInsertApi2] = useState(false); // 우측 등록
    let [deleteApi2, setDeleteApi2] = useState(false); // 우측 삭제

    const [clearGrid2, setClearGrid2] = useState(false);

    // ─── 품목 추가 팝업 ──────────────────────────────────────────────────
    const [ptnoPopupOpen, setPtnoPopupOpen] = useState(false);

    const [panded, setPanded] = useState(true);
    const [style, setStyle] = useState({
        height: "calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)"
    });

    // ─── Clear API ───────────────────────────────────────────────────────
    const onClearApi = useCallback(async () => {
        setSearchApi(false);
        setInsertApi(false);
        setUpdateApi(false);
        setDeleteApi(false);
    }, []);

    const onClearApi2 = useCallback(async () => {
        setSearchApi2(false);
        setInsertApi2(false);
        setDeleteApi2(false);
    }, []);

    // ─── Mount: 품번 목록 조회 (/rom4l/search) ──────────────────────────
    useEffect(() => {
        onSearchPtnoList();
        onSearch(); // 초기 전체 조회
    }, []);

    /**
     * 품번 목록 조회 - /rom4l/search
     */
    const onSearchPtnoList = async () => {
        // const para = `{"kVnt1":"${idata.kVnt1}"}`;
        //   let para = `{"kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","kPlnt":"${idata.kPlnt}"}`;
        let para = `{"kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","kPlnt":"101A"}`;
        const param = encodeURI(para);
        const query = SERVER_URL + "/rom4l/search?query=" + param;
        await fetch(query, { headers: { Authorization: token } })
            .then(resp => resp.json())
            .then(data => {
                if (data.success && data.data) {
                    console.log("ptno 조회")
                    console.log(data.data)
                    const codes = data.data.map(item => item.wdcptno);
                    const mapObj = {};
                    data.data.forEach(item => { mapObj[item.wdcptno] = item.wdcptno; });
                    setPtnoList(codes);
                    setPtnoMap(mapObj);
                }
            })
            .catch(() => { });
    };

    // ─── 조회 ─────────────────────────────────────────────────────────────
    /**
     * 좌측: 그룹코드 조회
     */
    const onSearch = async () => {
        const para = `{"kVnt1":"${idata.kVnt1}","grtp":"${idata.kGrtp}","gryn":"${idata.kGryn}"}`;
        const param = encodeURI(para);
        const query = SERVER_URL + "/rst03/wagr/search?query=" + param;
        setSearchApi(query);
        setClearGrid2(true);

    };

    /**
     * 우측: 그룹코드별 품목 조회
     */
    const onSearch2 = async (grtp) => {
        const target = grtp || currentGrtp;
        if (!target) return;
        const para = `{"kVnt1":"${idata.kVnt1}","grtp":"${target}"}`;
        const param = encodeURI(para);
        const query = SERVER_URL + "/rst03/wapt/search?query=" + param;
        setSearchApi2(query);
    };

    // ─── 좌측 그리드 Row 클릭 → 우측 조회 ───────────────────────────────
    const grdMain_onRowClicked = async (e) => {
        const grtp = e.data?.grtp;
        if (grtp) {
            setCurrentGrtp(grtp);
            onSearch2(grtp);
        }
    };

    // ─── 좌측 CRUD ─────────────────────────────────────────────────────
    const onAddRow = async () => {
        const newItems = { vand: idata.kVnt1, gocd: "ADD" };
        grdRST03Main.current.addRow(newItems, 0);
    };

    const onInsert = async () => {
        const selectedData = grdRST03Main.current.getSelectedNodes();
        if (selectedData.length === 0) {
            setMessage({ openAlert: true, severity: "info", msg: "선택된 데이터가 없습니다." });
            return;
        }
        // 필수값 체크
        for (const node of selectedData) {
            if (!node.data.grtp) {
                setMessage({ openAlert: true, severity: "warning", msg: "그룹코드를 입력해 주세요." });
                return;
            }
            if (!node.data.grnm) {
                setMessage({ openAlert: true, severity: "warning", msg: "그룹코드명을 입력해 주세요." });
                return;
            }
            if (!node.data.gryn) {
                setMessage({ openAlert: true, severity: "warning", msg: "사용여부를 입력해 주세요." });
                return;
            }
        }
        setInsertApi(SERVER_URL + "/rst03/wagr/insert");
    };

    const onUpdate = async () => {
        const selectedData = grdRST03Main.current.getSelectedNodes();
        if (selectedData.length === 0) {
            setMessage({ openAlert: true, severity: "info", msg: "수정할 데이터를 선택해 주세요." });
            return;
        }
        setUpdateApi(SERVER_URL + "/rst03/wagr/update");
    };

    const onDelete = async () => {
        const selectedData = grdRST03Main.current.getSelectedNodes();
        if (selectedData.length === 0) {
            setMessage({ openAlert: true, severity: "info", msg: "선택한 데이터가 없습니다." });
            return;
        }
        setDlgMessage({ openDlg: true, dlgTrans: "D1", dlgMsg: "선택한 그룹코드를 삭제하시겠습니까?" });
    };

    // ─── 우측 CRUD ─────────────────────────────────────────────────────
    const onAddRow2 = async () => {
        if (!currentGrtp) {
            setMessage({ openAlert: true, severity: "info", msg: "좌측에서 그룹코드를 먼저 선택해 주세요." });
            return;
        }
        const newItems = { vand: idata.kVnt1, grtp: currentGrtp, gocd: "ADD" };
        grdRST03Detail.current.addRow(newItems, 0);
    };

    const onInsert2 = async () => {
        if (!currentGrtp) {
            setMessage({ openAlert: true, severity: "info", msg: "좌측에서 그룹코드를 먼저 선택해 주세요." });
            return;
        }
        const selectedData = grdRST03Detail.current.getSelectedNodes();
        if (selectedData.length === 0) {
            setMessage({ openAlert: true, severity: "info", msg: "선택된 데이터가 없습니다." });
            return;
        }
        for (const node of selectedData) {
            if (!node.data.ptno) {
                setMessage({ openAlert: true, severity: "warning", msg: "품번을 선택해 주세요." });
                return;
            }
        }
        // grtp 주입
        selectedData.forEach(node => { node.data.grtp = currentGrtp; });
        setInsertApi2(SERVER_URL + "/rst03/wapt/insert");
    };

    const onDelete2 = async () => {
        const selectedData = grdRST03Detail.current.getSelectedNodes();
        if (selectedData.length === 0) {
            setMessage({ openAlert: true, severity: "info", msg: "선택한 데이터가 없습니다." });
            return;
        }
        setDlgMessage({ openDlg: true, dlgTrans: "D2", dlgMsg: "선택한 품목을 삭제하시겠습니까?" });
    };

    // ─── AlertDialog 결과 처리 ───────────────────────────────────────────
    const AlertDialogResult = async (e) => {
        setDlgMessage({ openDlg: false, dlgTrans: "", dlgMsg: "" });
        if (e.result === "N") return;
        switch (e.Trans) {
            case "D1":
                setDeleteApi(SERVER_URL + "/rst03/wagr/delete");
                break;
            case "D2":
                setDeleteApi2(SERVER_URL + "/rst03/wapt/delete"); // api 생성필요
                break;
            default:
                break;
        }
    };

    // ─── 품번 선택 시 품명 자동 셋팅 ────────────────────────────────────
    const grdDetail_onCellValueChanged = async (e) => {
        if (e.colDef.field === "ptno" && e.newValue) {
            const ptnm = ptnoMap[e.newValue] || "";
            e.node.setDataValue("ptnm", ptnm);
        }
    };

    // ─── Control 변경 ────────────────────────────────────────────────────
    const onChange = async (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    // ─── 검색조건 ────────────────────────────────────────────────────────
    const optionsX = {
        0: [
            {
                "formatter": "input", "name": "kGrtp", "labelName": "그룹코드", "type": "text",
                "defaultValue": idata.kGrtp, "align": "left", "labelType": "none"
            },
            {
                "formatter": "select", "name": "kGryn", "labelName": "사용구분", "type": "text",
                "defaultValue": idata.kGryn,
                "codeMode": false, "selectAll": "",
                "codes": useYnList,
                "comms": null,
            },
            { "formatter": "blank", "align": "right" },
            { "formatter": "blank", "align": "right" },
            { "formatter": "blank", "align": "right" },
        ]
    };

    // ─── Column 정의 ─────────────────────────────────────────────────────
    // 좌측: 그룹코드
    const columnDefs1 = [
        { headerName: "업체코드(h)", field: "vand", hide: true },
        {
            headerName: "그룹코드", field: "grtp",
            sortable: true, filter: true, flex: 1, minWidth: 120,
            editable: true, headerClass: "editCellOnlySub",
            cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: true, hide: false,
            checkboxSelection: true, headerCheckboxSelection: true,
        },
        {
            headerName: "그룹코드명", field: "grnm",
            sortable: true, filter: true, flex: 2, minWidth: 160,
            editable: true, headerClass: "editCellOnlySub",
            cellClass: ["nocheckbox", "alignL"],
            singleClickEdit: true, hide: false,
        },
        {
            headerName: "사용여부", field: "gryn",
            sortable: true, filter: true, flex: 1, minWidth: 90,
            editable: true, headerClass: "editCellOnlySub",
            cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: true, hide: false,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: { values: ["Y", "N"] },
        },
    ];

    // 우측: 그룹코드 품목
    const columnDefs2 = useMemo(() => [
        { headerName: "그룹코드(h)", field: "grtp", hide: true },
        { headerName: "업체코드(h)", field: "vand", hide: true },
        {
            headerName: "품번", field: "ptno",
            sortable: true, filter: true, flex: 2, minWidth: 160,
            editable: true, headerClass: "editCellOnlySub",
            cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: true, hide: false,
            checkboxSelection: true, headerCheckboxSelection: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: { values: ptnoList },
        },
        {
            headerName: "품명", field: "ptnm",
            sortable: true, filter: true, flex: 3, minWidth: 200,
            editable: false, headerClass: "",
            cellClass: ["nocheckbox", "alignL"],
            singleClickEdit: false, hide: false,
        },
    ], [ptnoList]);

    // ─── Layout 컨트롤 ───────────────────────────────────────────────────
    const onClick = async () => {
        setPanded(!panded);
        if (panded === true) {
            setStyle({ height: "calc(100vh - 65px - 35px - 50px - 21px - 8px)" });
        } else {
            setStyle({ height: "calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)" });
        }
    };

    // ─── Render ──────────────────────────────────────────────────────────
    return (
        <>
            {/* Dialog FRAME */}
            <AlertDialog open={openDlg} trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            {/* 품목 추가 팝업 (GrpPtno) */}
            <Popup
                type={"GrpPtno"}
                open={ptnoPopupOpen}
                wrcd={currentGrtp}
                vnt1={idata.kVnt1}
                onClose={(refresh) => {
                    setPtnoPopupOpen(false);
                    if (refresh === true) onSearch2(); // 확인 후 우측 그리드 재조회
                }}
            />

            {/* Alert FRAME */}
            <CustomAlert
                open={openAlert} severity={severity} duration={5000} message={msg}
                onClose={() => { setMessage({ openAlert: false, severity: "", msg: "" }); }}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            />

            {/* Ribbon Frame */}
            <Ribbon
                onInfoManual={false}
                onSearch={onSearch} onSearchName={null}
            >
                {"실사재고 > 기준정보 > "}
                <b style={{ color: "#cd5c5c", fontFamily: "PretendardMedium, NanumGothic, sans-serif" }}>
                    품목그룹등록
                </b>
            </Ribbon>

            {/* 검색조건 */}
            <ContentXearch optionsX={optionsX} onChange={onChange} onClick={onClick} />

            {/* Content FRAME */}
            <Content style={style}>
                <div className="grid_type02">

                    {/* 좌측: 그룹코드 */}
                    <div className="grid_wrap02" style={{ width: "50%", height: "100%" }}>
                        <div className="grid_area">
                            <GridRibbon
                                title={"그룹코드"}
                                onSearch={onSearch} onSearchName={"조회"}
                                onAddRow={onAddRow} onAddRowName={"신규"}
                                onInsert={onInsert} onInsertName={"입력"}
                                onUpdate={onUpdate} onUpdateName={"수정"}
                                onDelete={onDelete} onDeleteName={"삭제"}
                            />
                            <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                                <Grid
                                    ref={grdRST03Main}
                                    gridId={"RST031"}
                                    columnDefs={columnDefs1}
                                    pagination={false}
                                    paginationCsv={false}
                                    paginationPageSize={"1000"}
                                    rowMultiSelectWithClick={true}
                                    suppressRowClickSelection={false}
                                    rowSelection={"multiple"}
                                    enableRangeSelection={false}
                                    enableCellTextSelection={true}
                                    isFirst={true}
                                    displayNo={false}
                                    searchApi={searchApi}
                                    insertApi={insertApi}
                                    updateApi={updateApi}
                                    deleteApi={deleteApi}
                                    onClearApi={onClearApi}
                                    insertRefresh={onSearch}
                                    updateRefresh={onSearch}
                                    deleteRefresh={onSearch}
                                    onRowClickEvent={grdMain_onRowClicked}
                                    onCellValueChangedEvent={async () => { }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 우측: 그룹코드 품목 */}
                    <div className="grid_wrap03" style={{ width: "50%", height: "100%" }}>
                        <div className="grid_area">
                            <GridRibbon
                                title={"그룹코드 품목등록"}
                                onDelete={onDelete2} onDeleteName={"삭제"}
                            >
                                {/* 품목 추가 버튼 */}
                                <div >
                                    <button
                                        onClick={() => {
                                            if (!currentGrtp) {
                                                setMessage({ openAlert: true, severity: "info", msg: "좌측에서 그룹코드를 먼저 선택해 주세요." });
                                                return;
                                            }
                                            setPtnoPopupOpen(true);
                                        }}
                                        style={{
                                            display: "flex",
                                            flexFlow: "row nowrap",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            height: "30px",
                                            border: "1px solid #B7BCD6",
                                            borderRadius: "2px",
                                            background: "#fff",
                                            marginLeft: "10px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            paddingRight: "10px",
                                            paddingLeft: "10px",
                                            fontSize: "13px",
                                            fontFamily: "PretendardLight, NanumGothic, sans-serif",
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.background = "#E8ECF5"}
                                        onMouseLeave={e => e.currentTarget.style.background = "#fff"}
                                    >
                                        + 품목 추가
                                    </button>
                                </div>
                            </GridRibbon>
                            <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                                <Grid
                                    ref={grdRST03Detail}
                                    gridId={"RST032"}
                                    columnDefs={columnDefs2}
                                    pagination={false}
                                    paginationCsv={false}
                                    paginationPageSize={"1000"}
                                    rowMultiSelectWithClick={true}
                                    suppressRowClickSelection={true}
                                    rowSelection={"multiple"}
                                    enableRangeSelection={false}
                                    enableCellTextSelection={true}
                                    isFirst={true}
                                    displayNo={false}
                                    searchApi={searchApi2}
                                    insertApi={insertApi2}
                                    deleteApi={deleteApi2}
                                    onClearApi={onClearApi2}
                                    insertRefresh={() => onSearch2()}
                                    deleteRefresh={() => onSearch2()}
                                    clearGrid={clearGrid2}
                                    onClearGridFlag={setClearGrid2}
                                    onCellValueChangedEvent={grdDetail_onCellValueChanged}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </Content>
        </>
    );
}

export default RST03;
